import { Stack as FluentStack } from '@fluentui/react/lib/Stack';

/**
 * @deprecated Please use CoreUI's [Flex and FlexItem components](https://yammer-client-storybook.azurewebsites.net/yammer-web-core-ui/?path=/story/layout-flex--overview) instead.
 */
const Stack = FluentStack;

export default Stack;
export * from '@fluentui/react/lib/Stack';
